import Field from "src/components/field/Field";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useWindowSize from "src/hooks/useWindowSize";

interface TaskDetailEditorProps {
	className?: string;
}

const TaskDetailEditor = ({ className }: TaskDetailEditorProps) => {
	const { isPhone } = useWindowSize();
	const { task, actions } = useTaskForm();

	return (
		<div className={`${!isPhone && "container"} ${className}`}>
			<Field.Editor
				value={task.description}
				onChange={(value) => {
					actions.set({
						description: value,
					});
				}}
			/>
		</div>
	);
};

export default TaskDetailEditor;
